<template>
    <div class="component component__system_uploader_xls">
        <input
            ref="uploader"
            class="component__system_uploader_xls_input"
            type="file"
            accept=".xlsx"
            :name="name | toKebabCase"
            :id="`system-uploader-xls-input-${name}`"
            @change="setFile"
        >
    </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  name: 'component-system-uploader-xls',
  data () {
    return {
      file: []
    }
  },
  props: {
    name: {
      type: String,
      default: 'system-uploader'
    },
    uploadDispatchName: {
      type: String,
      default: 'lmsSuperadminUsersBulkSetUsers'
    },
    setFileDispatchName: {
      type: String,
      default: 'lmsSuperadminUsersBulkSetFile'
    }
  },
  methods: {
    openFileUploader () {
      this.$refs.uploader.click()
    },
    setFile () {
      this.file = this.$refs.uploader.files[0]
      const file = this.file
      let fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        let data = new Uint8Array(e.target.result)
        let workbook = XLSX.read(data, { type: 'array' })
        let sheet = workbook.Sheets.Sheet1
        let output = XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false })
        let outputAsArrays = output.map(obj => Object.values(obj))

        this.$store.dispatch(this.setFileDispatchName, file.name)
        this.$store.dispatch(this.uploadDispatchName, outputAsArrays)
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'XLS upload',
          message: `XLS file uploaded.`,
          status: 'success'
        })
      }
      fileReader.onerror = () => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'XLS upload',
          message: `XLS file not uploaded. Try again or contact an administrator.`,
          status: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentsystemuploaderxls";
</style>
